import { useQuery } from '@tanstack/react-query'
import { api, type HelperStatusResponse } from '../lib/api'
import { queries } from '../lib/queries'
import { polling } from '../lib/polling'

export function useHelperStatus(options?: { enabled?: boolean }) {
  return useQuery<HelperStatusResponse>({
    queryKey: queries.helper.status(),
    queryFn: () => api.getHelperStatus(),
    refetchInterval: polling.helperStatus,
    enabled: options?.enabled !== false,
    staleTime: 1_000,
  })
}
